function parseRgbChannel(value: string) {
  return Number.parseInt(value.trim(), 10)
}

export function tokenValueToHex(value: string) {
  if (typeof document === 'undefined') {
    return '#000000'
  }

  const element = document.createElement('div')
  element.style.color = value
  document.body.appendChild(element)
  const computed = getComputedStyle(element).color
  document.body.removeChild(element)

  const match = computed.match(/rgba?\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})/i)

  if (!match) {
    return '#000000'
  }

  const channels = match.slice(1, 4).map(parseRgbChannel)

  return `#${channels
    .map((channel) => channel.toString(16).padStart(2, '0'))
    .join('')}`
}
